/**
 * Catalog category strings as they arrive from the mock/API (English keys).
 * Insertion order is the Marketplace Filters prototype order. Filter `value`s
 * stay these English strings so they still match `item.category`.
 */
export const CATEGORY_I18N_KEYS = {
  Communication: 'integrations.catalog.categories.communication',
  'Productivity & Docs': 'integrations.catalog.categories.productivityDocs',
  'CRM & Sales': 'integrations.catalog.categories.crmSales',
  'Ticketing & ITSM': 'integrations.catalog.categories.ticketingItsm',
  'Data & Analytics': 'integrations.catalog.categories.dataAnalytics',
  Storage: 'integrations.catalog.categories.storage',
  'Dev & Code': 'integrations.catalog.categories.devCode',
  'HR & People': 'integrations.catalog.categories.hrPeople',
  'Finance & ERP': 'integrations.catalog.categories.financeErp',
  'Security & Observability': 'integrations.catalog.categories.securityObservability',
  'Custom / Build your own': 'integrations.catalog.categories.custom',
};

/**
 * Localized category label. Filter values stay English so search/filter still match `item.category`.
 */
export function catalogCategoryLabel(category, t) {
  if (!category) return '';
  const key = CATEGORY_I18N_KEYS[category];
  if (!key || typeof t !== 'function') return category;
  const label = t(key);
  return !label || label === key ? category : label;
}
